import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Self-hosted fonts (latin only, exact weights used in the design system).
// Eliminates the Google Fonts request chain and shrinks LCP on mobile.
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/poppins/latin-600.css";
import "@fontsource/poppins/latin-700.css";

createRoot(document.getElementById("root")!).render(<App />);
